import { render, staticRenderFns } from "./basic-data.vue?vue&type=template&id=1a259830&scoped=true"
import script from "./basic-data.vue?vue&type=script&lang=js"
export * from "./basic-data.vue?vue&type=script&lang=js"
import style0 from "./basic-data.vue?vue&type=style&index=0&id=1a259830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a259830",
  null
  
)

export default component.exports